import axios from "axios";

axios.defaults.withCredentials = true;

// Désactiver le cache
axios.defaults.headers.common["Cache-Control"] = "no-cache";
axios.defaults.headers.common["Pragma"] = "no-cache";
axios.defaults.headers.common["Expires"] = "0";

const hostname = window.location.hostname;

let backendURL = "";

if (hostname === "localhost") {
    backendURL = "http://localhost:3001/api";
}
else if (hostname === "192.168.88.250") {
    backendURL = "http://192.168.88.250:3001/api";
}
else {
    backendURL = process.env.REACT_APP_API_BASE_URL;
}

axios.defaults.baseURL = backendURL;


//window.location.hostname

//const backendURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api";
//const backendURL = "http://localhost:3001/api";
//console.log("Axios base URL:", backendURL);

// Intercepteur pour gérer les erreurs d'auth
axios.interceptors.response.use(
    (response) => response,
    (error) => {

        if (
            /*(error.response?.status === 401 || error.response?.status === 403) && !window.location.pathname.includes("/dcca") */
            (error.response?.status === 401 || error.response?.status === 403) &&
            !window.location.pathname.includes("/dcca") &&
            window.location.pathname !== "/" &&       // Protège la page d'accueil
            window.location.pathname !== "/login"     // Évite les boucles

        ) {
            window.location.href = "/login";
            localStorage.removeItem("token");

        }

/*         if (error.response?.status === 401 || error.response?.status === 403) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
 */        return Promise.reject(error);
    }
);

export default axios;


/* import axios from "axios";

axios.defaults.withCredentials = true;

const hostname = window.location.hostname;

const backendURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";
 */
//let backendURL = "http://localhost:3001";

/* if (hostname === "192.168.88.224") {
    backendURL = "http://192.168.88.224:3001";
} else if (hostname === "dcca.mg" || hostname === "www.dcca.mg") {
    backendURL = "https://dcca.mg";
}
console.log(backendURL);
axios.defaults.baseURL = backendURL; */

/* // 🔐 INTERCEPTEUR (C'EST ÇA LA SOLUTION)
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
); */
//export default axios;
